import { render, staticRenderFns } from "./AttentionWidget.vue?vue&type=template&id=ac810eea&scoped=true&"
import script from "./AttentionWidget.vue?vue&type=script&lang=js&"
export * from "./AttentionWidget.vue?vue&type=script&lang=js&"
import style0 from "./AttentionWidget.vue?vue&type=style&index=0&id=ac810eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac810eea",
  null
  
)

export default component.exports